"use strict";
// Tracks proposed changes for a given user's careplan section
var Model = require("../types/Model.js");
var xtend = require("xtend");


module.exports = Model({
	name: "careplanproposedchanges",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_section: "",
	_change_tracker: null,

	refresh: refresh,
	reset: reset,
	track: track,
});

function listeners() {
	return {
		"connectivity:online": refresh,
	};
}

function triggers() {
	return {
		view: view,
		reset: reset,
	};
}

function init() {
	this._change_tracker = this.dispatcher.createTracker();

	this.reset();
}

function uninit() {
	this.reset();
	this._change_tracker = null;
}

function track() {
	var tracker = this._change_tracker;
	tracker.off();
	var section = this._section;

	if(!section)
		return;

	tracker.on("mqtt:$/careplan/" + section + "/changes/proposed", handle_add.bind(this));
	tracker.on("mqtt:$/careplan/" + section + "/changes/confirmed", updateItem.bind(this));
	tracker.on("mqtt:$/careplan/" + section + "/changes/denied", removeItem.bind(this));
	tracker.on("mqtt:$/careplan/" + section + "/changes/committed", updateItem.bind(this));
	tracker.on("mqtt:$/careplan/changes/synchronized", handle_synch.bind(this));
}

function handle_synch() {
	var list = this.data;
	var updated = list.filter(function(item) {
		return item.state !== "committed";
	});
	this.push(updated);
}

function handle_add(data) {
	var list = this.data;
	var proccessedData = processItem(data);
	var all = list.concat(proccessedData);

	this.push(all);
}

function updateItem(data) {
	var id = data._id;
	var items = this.data;
	var updated = items.map(function(item){
		var proccessedData = processItem(data);
		if(item._id === id)
			return xtend(item, proccessedData);
		return item;
	});

	this.push(updated);
}

function removeItem(data) {
	var id = data._id;
	var items = this.data;
	var filtered = items.filter(function (item) {
		return item._id !== id;
	});

	this.push(filtered);
}

function refresh() {
	var section = this._section;

	if(!section)
		return;

	this.emit("save:trigger:start");
	this.api.careplan
		.changes.pending.list(section)
		.then(handle_loaded.bind(this))
		.catch(console.error.bind(this))
		.then(finishSave.bind(this));
}

function finishSave() {
	this.emit("save:trigger:finish");
}

function handle_loaded(list) {
	this.push(list.map(processItem));
}

function processItem(item) {
	return xtend(item, {
		changes: item.changes.map(processChange)
	});
}

function processChange(change) {
	var value = change.value || "";
	return xtend(change, {
		value: value
	});
}

function view(data) {
	var section = data.section;
	if(section === this._section)
		return;

	this._section = section;
	this.track();
	this.refresh();
}

function reset() {
	this._section = "";
	this._change_tracker.off();
	this.push([]);
}
